/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnvironmentStats } from "./EnvironmentStats";
export const EnvironmentStatsResponse = core.serialization.object({
    data: EnvironmentStats.optional(),
});
